import store from "../app/store";

/**
 * Sends a URL and UUID to the backend to trigger a domain crawl process.
 *
 * - POSTs to `/crawl/processCrawlLinks` with a max link count.
 * - Requires authentication token from Redux store.
 * - Used for large-scale page crawling and indexing based on a specific user UUID.
 *
 * @async
 * @function ProcessCrawlDmain
 * @param {string} urlToCrawl - The full domain URL to crawl.
 * @param {string} uuid - Unique user or session identifier.
 * @returns {Promise<{
 *   data: Object | Array,
 *   error: boolean
 * }>} A promise resolving to:
 * - `data`: API response data or empty array on failure.
 * - `error`: Boolean indicating success/failure.
 *
 * @example
 * const { data, error } = await ProcessCrawlDmain("https://example.com", "123e4567");
 * if (!error) {
 *   console.log("Crawled data:", data);
 * } else {
 *   console.error("Crawl failed");
 * }
 */

const ProcessCrawlDmain = async (urlToCrawl, uuid, botId) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/crawl/processCrawlLinks`;

  console.log("uuid-res", uuid);

  const token = store.getState().auth.token;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      url: urlToCrawl,
      max_count: 5000,
      uuid: uuid,
      botId,
    }),
  };

  try {
    const res = await fetch(url, options);

    if (!res.ok) {
      return { data: [], error: true };
    }

    const data = await res.json();
    return { data, error: false };
  } catch (err) {
    return { data: [], error: true };
  }
};

export default ProcessCrawlDmain;
